export enum FormInputModifier {
  INVERTED = 'form-input--inverted',
}
